var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMangment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.068,
    height: 97,
    viewBox: "0 0 71.068 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #6283a3;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #294b6e;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #ffb531;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #ffcb73;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #fca713;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Authentication",
    "data-name": "User Authentication",
    transform: "translate(-44 -29.318)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    className: "cls-1",
    y2: 97,
    transform: "translate(55.534 29.318)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    className: "cls-2",
    d: "M66.309,81.638a13.745,13.745,0,0,1-.1-1.666,13.312,13.312,0,0,1,9.61-12.792,6.662,6.662,0,0,1,3.716-12.193V35a35.534,35.534,0,0,0,0,71.068V81.638Z",
    transform: "translate(0 6.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    className: "cls-3",
    d: "M60,35V54.988a6.577,6.577,0,0,1,2.221.409v-.262H78.575V51.5a6.361,6.361,0,0,0-12.721,0H64.038a8.177,8.177,0,0,1,16.354,0v3.636h1.817V67.853h-.071l.071.056H65.639a13.3,13.3,0,0,1,7.686,12.064,13.749,13.749,0,0,1-.1,1.666H60v24.43A35.534,35.534,0,1,0,60,35Z",
    transform: "translate(19.534 6.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    className: "cls-4",
    d: "M60.663,50.663a6.658,6.658,0,0,0,2.947,5.53A13.312,13.312,0,0,0,54,68.985a13.749,13.749,0,0,0,.1,1.666H67.325V44A6.662,6.662,0,0,0,60.663,50.663Z",
    transform: "translate(12.209 17.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    className: "cls-4",
    d: "M73.225,70.65a13.749,13.749,0,0,0,.1-1.666,13.3,13.3,0,0,0-7.686-12.064H62.221l.064-.056h-.064V44.409A6.578,6.578,0,0,0,60,44V70.65Z",
    transform: "translate(19.534 17.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    className: "cls-5",
    d: "M61,44.066v.262a6.355,6.355,0,0,1,.671.278C61.251,44.286,61,44.066,61,44.066Z",
    transform: "translate(20.755 17.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    className: "cls-5",
    d: "M62,45.654a6.582,6.582,0,0,1,.591,9.252c3.656-2.039,10.367-4.184,17.1,1.879h.071V44.066C72.619,50.56,65.5,47.773,62,45.654Z",
    transform: "translate(21.979 17.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    className: "cls-5",
    d: "M61.064,56.641a16.972,16.972,0,0,1,2.754-1.879,6.582,6.582,0,0,0-.591-9.252,18.759,18.759,0,0,1-1.557-1.048A6.356,6.356,0,0,0,61,44.184V56.641Z",
    transform: "translate(20.755 17.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    className: "cls-6",
    d: "M63.228,45.654c3.493,2.119,10.616,4.906,17.76-1.588H61s.251.22.671.54A6.628,6.628,0,0,1,63.228,45.654Z",
    transform: "translate(20.755 17.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    className: "cls-6",
    d: "M62.859,45.357A6.628,6.628,0,0,0,61.3,44.309,18.761,18.761,0,0,0,62.859,45.357Z",
    transform: "translate(21.123 17.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    className: "cls-7",
    d: "M62.621,49.849h16.57l-.071-.056H62.472C62.521,49.815,62.574,49.826,62.621,49.849Z",
    transform: "translate(22.552 24.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    className: "cls-7",
    d: "M61.064,49.793,61,49.849h3.418c-.047-.022-.1-.033-.149-.056Z",
    transform: "translate(20.755 24.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    className: "cls-7",
    d: "M63,50.1a6.692,6.692,0,0,1-1.324,1.206,13.209,13.209,0,0,1,1.774.673H80.1C73.364,45.917,66.652,48.062,63,50.1Z",
    transform: "translate(21.576 22.047)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    className: "cls-7",
    d: "M62.459,50.153a6.692,6.692,0,0,0,1.324-1.206,16.973,16.973,0,0,0-2.754,1.879h3.2A13.207,13.207,0,0,0,62.459,50.153Z",
    transform: "translate(20.79 23.201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    className: "cls-4",
    d: "M78.172,46.924a8.177,8.177,0,1,0-16.354,0h1.817a6.361,6.361,0,0,1,12.721,0V50.56h1.817Z",
    transform: "translate(21.753 10.748)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMangment);
export default __webpack_public_path__ + "static/media/UserMangment.dd7e288bd772ce9dd12e18dca17be2d1.svg";
export { ForwardRef as ReactComponent };